import { useSelector } from '@/api/state';
import ListedLineItemGroups from '@/ui/components/listedLineItemGroups/ListedLineItemGroups';
import { PermissionGuard } from '@/ui/components/permissionGuard/PermissionGuard';
import { Button } from '@payaca/ambrosia';
import { LineItemsPermissions } from '@payaca/permissions/lineItems/line-items.permissions';
import * as lineItemGroupActions from '@payaca/store/lineItemGroups/lineItemGroupsActions';
import { FC, useEffect, useMemo, type JSX } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ListViewPageWrapper from '../pageWrappers/listViewPageWrapper/ListViewPageWrapper';
import './ListedItemGroupsPage.sass';

const ListedItemGroupsPage: FC = (): JSX.Element => {
  const dispatch = useDispatch();
  const history = useHistory();

  const lineItemGroups = useSelector(
    (state) => state.lineItemGroups.lineItemGroups
  );

  const createdLineItemGroupId = useSelector(
    (state) => state.lineItemGroups.createLineItemGroupSuccessId
  );

  const listedLineItemGroups = useMemo(
    () => Object.values(lineItemGroups),
    [lineItemGroups]
  );

  useEffect(() => {
    dispatch(lineItemGroupActions.requestGetLineItemGroups());
    return () => {
      dispatch(lineItemGroupActions.clearCreateLineItemGroup());
    };
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'dispatch'
  }, []);

  useEffect(() => {
    if (createdLineItemGroupId) {
      history.push(`/items/groups/${createdLineItemGroupId}`);
    }
    // oxlint-disable-next-line react-hooks/exhaustive-deps -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'history'
  }, [createdLineItemGroupId]);

  return (
    <ListViewPageWrapper
      breadcrumbItems={[
        { label: 'Back to items', to: '/items' },
        { label: 'Item groups' },
      ]}
      className="listed-item-groups-page"
      title={
        <div className="flex space-x-3.5 items-center">
          <div>
            <h1>Item groups</h1>
          </div>
          <PermissionGuard
            renderIfHasPermissions={[LineItemsPermissions.ADD_LINE_ITEM_GROUP]}
          >
            <Button
              size="sm"
              onClick={() =>
                dispatch(lineItemGroupActions.requestCreateLineItemGroup())
              }
            >
              Create item group
            </Button>
          </PermissionGuard>
        </div>
      }
      paginationConfig={{
        pageNumber: 1,
        totalItemCount: listedLineItemGroups.length,
        pageSize: listedLineItemGroups.length,
        onSelectPage: () => null,
      }}
    >
      <ListedLineItemGroups
        onLineItemGroupClick={(lineItemGroupId: number) =>
          history.push(`/items/groups/${lineItemGroupId}`)
        }
      />
    </ListViewPageWrapper>
  );
};

export default ListedItemGroupsPage;
